import React from 'react';
import { Typography } from '@mui/material';
import { createClasses } from '@kp/react-ui';
import classNames from 'classnames';

const classes = createClasses({
  root: {
    margin: '14px 0',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    minHeight: '52px',
    alignItems: 'center',
  },
  actions: {},
  title: {},
});

interface ActionsBarProps {
  title?: string | null;
  className?: string;
  children?: React.ReactNode;
}

export const ActionsBar: React.FC<ActionsBarProps> = ({
  title,
  className,
  children,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.title}>
        {title && <Typography variant="h5">{title}</Typography>}
      </div>
      <div className={classes.actions}>{children}</div>
    </div>
  );
};
